import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-economy-menu',
    templateUrl: './economy-menu.component.html',
    styleUrls: ['./economy-menu.component.css'],
})
export class EconomyMenuComponent {
    /**
     * The name of the economy webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
